const stepsActionsConstants = {
  GET_STEP_SUCCESS: 'GET_STEP_SUCCESS',
  GET_STEP: 'GET_STEP',
};
export default stepsActionsConstants;
